<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-divide class="table-tools">
      <div></div>
      <n-link v-if="edit.records" :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td rowspan="2">№ п/п</td>
          <td rowspan="2">Дата</td>
          <td rowspan="2">Конструктивные элементы линейной части трубопровода (переходы через преграды и инженерные коммуникации, насыпи и др.)</td>
          <td rowspan="2">Границы участка от км, ПК до км, ПК; привязка площадки</td>
          <td rowspan="2">Выполнение противопучинных и других присыпок дна траншеи (котлована) от км, ПК до км, ПК</td>
          <td rowspan="2">Выполнение нивелировки дна траншеи, котлована (подпись геодезиста)</td>
          <td rowspan="2">Замечания контролирующих лиц (технадзора заказчика и службы контроля качества)</td>
          <td rowspan="2">Отметка ответственного лица об устранении замечаний</td>
          <td colspan="2">Сдача-приемка работ</td>
          <td rowspan="2">Примечания</td>
          <td rowspan="2"></td>
        </tr>
        <tr class="header">
          <td>подпись руководителя работ</td>
          <td>подпись технадзора заказчика</td>
        </tr>
        <tr class="header">
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td>8</td>
          <td>9</td>
          <td>10</td>
          <td>11</td>
          <td></td>
        </tr>
      </template>
      <template #date="{item}">
        {{ $app.date.format(item.date) }} {{ item.shift }}
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
      <template #recordsSign="{item}">
        <c-journal-sign :sign="getSign(item, 'records')" />
      </template>
      <template #geodesistSign="{item}">
        <c-journal-sign :sign="getSign(item, 'geodesist')" />
      </template>
      <template #customerSign="{item}">
        <c-journal-sign :sign="getSign(item, 'customer')" />
      </template>
    </n-table>

    <div class="columns">
      <div>
        <div>Министерство <n-input inline style="width: 250px;" /></div>
        <div>Объединение, трест <n-input inline style="width: 250px;" /></div>
        <div>СМУ, СУ, ПМК, КТП <n-input inline style="width: 250px;" /></div>
        <div>Участок <n-input inline style="width: 250px;" /></div>
      </div>
      <div>
        <div>Форма № 2.5</div>
        <div>Основание: <n-input inline value="ВСН 012-88 (Часть II)" style="width: 250px;" /></div>
        <div>Миннефтегазстрой</div>
        <div>Строительство <n-input inline style="width: 250px;" /></div>
      </div>
    </div>

    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreate from './Create'
import ModalRecord from './record/Index'
import utils from 'utils'
import CJournalSign from 'components/journal/Sign'

export default {
  name: 'MainChapter4',
  components: { ModalRecord, PageRecordCreate, CJournalSign, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [
    ],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    edit() {
      return {
        records: $app.auth.can('journals_earth_records', this.project.id),
      }
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    columns() {
      return [
        { name: 'number', title: '', },
        { name: 'date', title: '', },
        { name: 'construction', title: '', },
        { name: 'border', title: '', },
        { name: 'completing', title: '', },
        { name: 'geodesistSign', title: '', },
        { name: 'remark', title: '', },
        { name: 'mark', title: '', },
        { name: 'recordsSign', title: '', },
        { name: 'customerSign', title: '', },
        { name: 'memo', title: '', },
        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, 'earth')
        .query({
          'with[author][with][participation]': null,
          'with[signs][with][author]': null,
          projectId: this.project.id,
        })
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {
  .columns {
    margin-top: 40px;
    display: flex;
    &>div {
      margin-right: 40px;
    }
  }
}
</style>
